<template>
<v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
  <v-dialog v-model="permitted_dialog" max-width="400px">
    <v-card>
      <v-card-text>
        <div class="text-center">
          <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
          <p>{{message}}</p>
          <v-progress-circular
            :size="70"
            :width="2"
            :value="100"
            color="error"
            class="mb-4 mr-4"
          >
            <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
          </v-progress-circular>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</v-container>
<v-container v-else v-show="permitted != null" class="pt-0" fluid>
  <v-snackbar
    :value="showMessage()"
    multi-line
    color="#686868"
    top
    
  >
    {{message}}
  </v-snackbar>

  <v-dialog persistent v-model="BlockingViolation" max-width="400px">
    <v-card>
      <v-card-text>
        <div class="text-center">
          <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-information-outline</v-icon>Blocking Value Violation</div>
          <p>Due to the Blocking Value set on the Client, the specified amount cannot be captured</p>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <div class="text-right mb-4">
          <v-btn class="white--text mr-3" small color="#2A353D" @click="BlockingViolation = false">
            ok
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-card flat >
  <v-toolbar dense flat color="#2A353D">
    <v-toolbar-title class="white--text subtitle-1 font-weight-normal">Purchase Money Market</v-toolbar-title>
    <v-spacer/>
    <span class="white--text caption font-weight-normal mr-3">Transacting Currency: {{Currency[0].CurrencyName}}</span>
    <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
    <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>
  </v-toolbar>
  </v-card>

<!-- ********************************************************************************************CREATE**************************************************************************************************
***************************************************************************************************************************************************************************************************** -->

  <v-form flat color="#ffffff00" ref="form" v-model="valid" lazy-validation v-if="create">
   <v-row>
      <v-col>
        <v-card class="pt-3" elevation="12">
          <v-row class="ml-1 mr-1">
            <v-col class="pb-0">
              <v-row>
                <v-col class="pb-0 pt-0">
                  <v-checkbox
                    @change="getAccounts(MMPurchase.purchase.CustodialID); MMPurchase.allocation = []; Taxable == true ? MMPurchase.purchase.TaxRate = allInstrumentTypes.filter(a => a.InstrumentTypeID == MMPurchase.purchase.InstrumentID).map(a => a.DefaultTaxRate)[0] : MMPurchase.purchase.TaxRate = 0; WithHoldingTax = 0"
                    v-model="Taxable"
                    class="mt-0"
                    label="Taxable"
                  ></v-checkbox>
                </v-col>
                <v-col class="pb-0 pt-0">
                  <v-checkbox
                    v-model="MMPurchase.purchase.IsPrescribed"
                    class="mt-0"
                    label="Prescribed"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-col>
            <v-col class="pb-0 text-right">
              <v-select
                @change="__getInterestDenominator()"
                outlined dense
                v-model="MMPurchase.purchase.FldVar01"
                :items="Basis"
                item-text="BasisDesc"
                item-value="BasisIdAlpha"
                placeholder="----"
                :rules="TextFieldRules"
                label="Deal Base"
              ></v-select>
            </v-col>
          </v-row>
          <v-row class="ml-1 mr-1">
            <v-col class="pb-0">
              <v-select
                outlined dense @change="getBalances(MMPurchase.purchase.CustodialID); getAccounts(MMPurchase.purchase.CustodialID); MMPurchase.allocation = []"
                v-model="MMPurchase.purchase.CustodialID"
                :items="DealCustodians"
                item-text="CustodianName"
                item-value="CustodianID"
                placeholder="----"
                :rules="TextFieldRules"
                label="Custodian"
              ></v-select>
              <v-row>
                <v-col class="pb-0 pt-0">
                  <v-text-field
                    light dense outlined
                    :value="balances.Available != null? (Number(balances.Available) - Number(MMPurchase.purchase.InstrumentValue)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                    color="#2A353D"
                    label="Available Balance"
                    readonly class="pb-0"
                    placeholder="----"
                    :prefix="Currency[0].CurrencySymbol"
                  ></v-text-field>
                </v-col>
                <v-col class="pb-0 pt-0">
                  <v-text-field
                    light dense outlined
                    :value="balances.Actual != null? Number(balances.Actual).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                    color="#2A353D"
                    label="Actual Balance"
                    readonly
                    placeholder="----"
                    :prefix="Currency[0].CurrencySymbol"
                  ></v-text-field>
                </v-col>
              </v-row>
                <v-text-field
                  light dense outlined
                  color="#2A353D"
                  v-model="MMPurchase.purchase.InstrumentValue"
                  @input="GetGrossInterest(MMPurchase.purchase, currentSystemDate.DayDate)"
                  label="Nominal Amount"
                  required
                  type="number"
                  :rules="[
                    v => !!v || 'field is required',
                    v =>  v <= Number(balances.Available) || 'Amount exceeds Available balance',
                  ]"
                  placeholder="----"
                ></v-text-field>
                <v-select
                  outlined dense
                  v-model="MMPurchase.purchase.SellerID"
                  :items="allCounterparties.filter(a => a.IsSeller == true && a.CheckerID != 0 && a.RejectionID == 0)"
                  item-text="CounterPartyName"
                  item-value="CounterPartyID"
                  placeholder="----"
                  :rules="TextFieldRules"
                  label="Counterparty"
                ></v-select>
                <v-row>
                  <v-col class="pb-0 pt-0">
                    <v-text-field
                      light dense outlined
                      color="#2A353D"
                      :disabled="!Taxable"
                      @input="getWith_holdingTax(MMPurchase.purchase)"
                      v-model="MMPurchase.purchase.TaxRate"
                      label="Tax Rate"
                      readonly
                      required
                      type="number"
                      placeholder="----"
                      suffix="%"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="pb-0 pt-0">
                    <v-text-field
                      light dense outlined
                      color="#2A353D"
                      :value="currentSystemDate.DayDate != null && MaturityDate != null && MMPurchase.purchase.Rate != null && MMPurchase.purchase.InstrumentValue != null ? GrossInterest : ''"
                      label="Gross Interest"
                      required
                      readonly
                      :rules="TextFieldRules"
                      placeholder="----"
                      :prefix="Currency[0].CurrencySymbol"
                    ></v-text-field>
                  </v-col>
                  <v-col class="pb-0 pt-0">
                    <v-text-field
                      light dense outlined
                      color="#2A353D"
                      :value="(Number(GrossInterest) * (Number(MMPurchase.purchase.TaxRate) / 100)).toFixed(2)"
                      label="With-holding Tax"
                      required
                      readonly
                      :rules="TextFieldRules"
                      placeholder="----"
                      :prefix="Currency[0].CurrencySymbol"
                    ></v-text-field>
                  </v-col>
                </v-row>
            </v-col>
            <v-col class="pb-0">

              <v-text-field
                :value="currentSystemDate.DayDate"
                label="Purchase Date"
                append-icon="mdi-calendar-month"
                readonly placeholder="--/--/--"
                dense outlined color="#2A353D"
              ></v-text-field>

              <v-row>
                <v-col class="pb-0 pt-0">
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    v-model="TenorDays"
                    @input="getMaturityDate(currentSystemDate.DayDate)"
                    label="Tenor Days"
                    type="number"
                    placeholder="----"
                    :rules="[
                      v => !!v || 'field is required',
                      v => v > 0 || 'Tenor should be > 0'
                    ]"
                  ></v-text-field>
                </v-col>
                <v-col class="pb-0 pt-0">
                  <v-menu
                    ref="menu_2"
                    v-model="menu_2"
                    :close-on-content-click="false"
                    :return-value.sync="MaturityDate"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="MaturityDate"
                        label="Maturity Date"
                        append-icon="mdi-calendar-month"
                        readonly placeholder="--/--/--"
                        dense outlined color="#2A353D"
                        :error-messages="errors"
                        :rules="CreateDateRules"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker @change="getTenorDays(currentSystemDate.DayDate)" color="#2A353D" v-model="MaturityDate" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn outlined small color="#2A353D" @click="menu_2 = false">Cancel</v-btn>
                    <v-btn outlined small color="#2A353D" @click="$refs.menu_2.save(MaturityDate)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>

              <v-select
                outlined dense
                @change="Taxable == true ? MMPurchase.purchase.TaxRate = allInstrumentTypes.filter(a => a.InstrumentTypeID == MMPurchase.purchase.InstrumentID).map(a => a.DefaultTaxRate)[0] : ''"
                v-model="MMPurchase.purchase.InstrumentID"
                :items="allInstrumentTypes.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                item-text="InstrumentTypeCode"
                item-value="InstrumentTypeID"
                placeholder="----"
                :rules="TextFieldRules"
                label="Instrument"
              ></v-select>

              <v-text-field
                light dense outlined
                color="#2A353D"
                v-model="MMPurchase.purchase.BrokerNote"
                label="Deal Note"
                :error-messages="BNerrors"
                :rules="[
                  v => !!v || 'field is required',
                  v => (v && v.length <= 50) || 'field must be less than 50 characters'
                ]"
                placeholder="----"
              ></v-text-field>

              <v-row>
                <v-col class="pb-0 pt-0">
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    v-model="MMPurchase.purchase.Rate"
                    label="Deal Rate"
                    @input="GetGrossInterest(MMPurchase.purchase, currentSystemDate.DayDate)"
                    type="number"
                    placeholder="----"
                    :rules="TextFieldRules"
                    suffix="%"
                  ></v-text-field>
                </v-col>
                <!-- <v-col class="pb-0 pt-0">
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    v-model="MMPurchase.purchase.Rate"
                    label="Client Rate"
                    @input="GetGrossInterest(MMPurchase.purchase, currentSystemDate.DayDate)"
                    type="number"
                    placeholder="----"
                    :rules="TextFieldRules"
                    suffix="%"
                  ></v-text-field>
                </v-col> -->
              </v-row>

              <v-row>
                <v-col class="pb-0 pt-0">
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    :value="MMPurchase.purchase.TaxRate != null && GrossInterest != null? Number(Number(GrossInterest) - (Number(GrossInterest) * (Number(MMPurchase.purchase.TaxRate) / 100))).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                    label="Net Interest"
                    readonly
                    placeholder="----"
                    :prefix="Currency[0].CurrencySymbol"
                  ></v-text-field>
                </v-col>
                <v-col class="pb-0 pt-0">
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    :value="MMPurchase.purchase.TaxRate != null && GrossInterest != null ? Number(Number(MMPurchase.purchase.InstrumentValue) + (Number(GrossInterest) - (Number(GrossInterest) * (Number(MMPurchase.purchase.TaxRate) / 100)))).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                    label="Maturity Value"
                    readonly placeholder="----"
                    :prefix="Currency[0].CurrencySymbol"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-data-table
      :headers="allocations_headers"
      :fixed-header="true"
      :items="MMPurchase.allocation"
      disable-pagination
      hide-default-footer dense
      class="elevation-12 my-allocations-table mt-3"
    >

      <template v-slot:top >
        <v-toolbar dense flat>
          <v-toolbar-title class="grey--text caption font-weight-normal">Allocations</v-toolbar-title>
          <v-spacer/>
          <v-btn class="text-right" @click="NewAllocation(MMPurchase.allocation)" x-small dark outlined fab color="#2A353D">
            <v-icon small >mdi-plus</v-icon>
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.AccountID="{ item }">
        <v-select
          @change="getCurrentAccountBalance(item)"
          @click="setActiveAllocation(item, index)"
          background-color="#ffffff00"
          v-model="item.AccountID"
          :items="Accounts"
          :menu-props="{ top: true, offsetY: true }"
          item-text="AccountName"
          item-value="AccountID"
          solo flat class="Account ma-0 pa-0 pt-5"
          placeholder="----" dense
          :rules="[
            v => !!v || 'field is required',
            v => MMPurchase.allocation.filter(a => a.AccountID == item.AccountID).length < 2 || 'Account already selected'
          ]"
        ></v-select>
      </template>

      <template v-slot:item.OpeningBalance="{ item }">
        {{Number(item.OpeningBalance).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
      </template>

      <template v-slot:item.FldNum02="{ item }">
        {{Number(getInterest(item, MMPurchase.purchase)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
      </template>

      <template v-slot:item.FldNum01="{ item }">
        {{Number(getMaturityValue(item)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
      </template>

      <template v-slot:item.AllocationRate="{ item }">
        {{Number(getAllocationRate(item, MMPurchase.purchase)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
        <!-- <span v-if="allClientAccounts.filter(a => a.AccountID == item.AccountID).map(a => a.CallAccountTypeID)[0] == 6">{{Number(getAllocationRate(item, MMPurchase.purchase)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
        <v-text-field
          v-else
          v-model="item.AllocationRate"
          label="Rate"
          @keydown="getNetValueValidation(MMPurchase.allocation, item)"
          :rules="[
            v => !!v || 'field is required',
            v =>  v <= 100 || 'Should be a percentage(%)',
          ]"
          single-line
          type="number"
        ></v-text-field> -->
      </template>

      <template v-slot:item.FldNum03="{ item }">
        {{Number(getCharges(item, MMPurchase.purchase)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 3})}}
      </template>

      <template  v-slot:item.AllocationValue="{ item }">
        <v-text-field
          v-model="item.AllocationValue"
          label="Amount"
          @keydown="getNetValueValidation(MMPurchase.allocation, item)"
          :rules="[
            v => !!v || 'field is required',
            v =>  v <= Number(item.OpeningBalance) || 'Over allocated',
          ]"
          single-line
          type="number"
        ></v-text-field>
      </template>

      <template v-slot:item.action="{ item }">
        <v-icon small @click="removeAllocation(item, MMPurchase.allocation)">mdi-close</v-icon>
      </template>

      <template v-slot:footer >
        <v-divider class="mt-0"/>
        <v-row class="ml-2 mr-2">
          <v-col class="pb-0 pt-7" cols="2">
          <v-text-field
            class="table-text-field"
            light dense
            :value="Number(getAllocatedValue(MMPurchase.allocation)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})"
            color="#2A353D"
            label="Allocated Value"
            readonly
            :rules="[() => getAllocatedValue(MMPurchase.allocation) == MMPurchase.purchase.InstrumentValue || 'should match Deal Value']"
            :prefix="Currency[0].CurrencySymbol"
          ></v-text-field>
          </v-col>
          <v-col class="pb-0 pt-7">
          <v-text-field
            class="table-text-field"
            light dense
            :value="Number(getAllocatedUnits(MMPurchase.allocation)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})"
            color="#2A353D"
            label="Total Maturity"
            readonly
            :rules="[() => Number(getAllocatedUnits(MMPurchase.allocation)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) == Number(Number(MMPurchase.purchase.InstrumentValue) + (Number(GrossInterest) - (Number(GrossInterest) * (Number(MMPurchase.purchase.TaxRate) / 100)))).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) || 'should match Maturity Value']"
          ></v-text-field>
          </v-col>
          <v-col class="pb-0 pt-7">
          <v-text-field
            class="table-text-field"
            light dense
            :value="MMPurchase.purchase.InstrumentValue != null ? Number(MMPurchase.purchase.InstrumentValue - getAllocatedValue(MMPurchase.allocation)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : 0"
            color="#2A353D"
            label="Remaining Amount"
            readonly
          ></v-text-field>
          </v-col>
          <v-col class="pb-0 pt-7" cols="6">
            <div class="text-right mb-4 mt-4">
              <v-btn class="white--text mr-4" small color="#2A353D" @click="closeCreate()">close</v-btn>
              <v-btn class="white--text" small color="#2A353D" :disabled="!valid || loading == true" @click="createNew()">
                <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                submit
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </template>
    </v-data-table>
  </v-form>

<!-- ********************************************************************************************EDIT**************************************************************************************************
***************************************************************************************************************************************************************************************************** -->

  <v-form flat color="#ffffff00" ref="form" v-model="valid" lazy-validation v-if="edit">
    <span class="d-flex flex-row mt-2">
      <span class="grey--text caption font-weight-normal">REFERENCE: <span class="subtitle-2">{{currentPurchase.DealNumber}}</span></span>
      <v-spacer/>
      <span class="mr-2 grey--text caption font-weight-normal">Maker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentPurchase.MakerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
      <span v-if="currentPurchase.CheckerID != 0" class="mx-2 grey--text caption font-weight-normal">Checker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentPurchase.CheckerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
      <span class="ml-2 grey--text caption font-weight-normal">Last User: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentPurchase.LastUserID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
    </span>
   <v-row>
      <v-col>
        <v-card class="pt-3" elevation="12">
          <v-row class="ml-1 mr-1">
            <v-col class="pb-0">
              <v-row>
                <v-col class="pb-0 pt-0">
                  <v-checkbox
                    @change="currentPurchase.allocations = []; currentPurchase.IsTaxable == true ? currentPurchase.TaxRate = allInstrumentTypes.filter(a => a.InstrumentTypeID == currentPurchase.InstrumentID).map(a => a.DefaultTaxRate)[0] : currentPurchase.TaxRate = 0; WithHoldingTax = 0"
                    v-model="currentPurchase.IsTaxable"
                    class="mt-0"
                    label="Taxable"
                  ></v-checkbox>
                </v-col>
                <v-col class="pb-0 pt-0">
                  <v-checkbox
                    v-model="currentPurchase.IsPrescribed"
                    class="mt-0"
                    label="Prescribed"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-col>
            <v-col class="pb-0 text-right">
              <v-select
                @change="__getInterestDenominator()"
                outlined dense
                v-model="currentPurchase.FldVar01"
                :items="Basis"
                item-text="BasisDesc"
                item-value="BasisIdAlpha"
                placeholder="----"
                :readonly="view"
                :rules="TextFieldRules"
                label="Deal Base"
              ></v-select>
            </v-col>
          </v-row>
          <v-row class="ml-1 mr-1">
            <v-col class="pb-0">
              <v-select
                outlined dense @change="getBalances(currentPurchase.CustodialID); getAccounts(currentPurchase.CustodialID); currentPurchase.allocations = []"
                v-model="currentPurchase.CustodialID"
                :items="DealCustodians"
                item-text="CustodianName"
                item-value="CustodianID"
                placeholder="----"
                :readonly="view"
                :rules="TextFieldRules"
                label="Custodian"
              ></v-select>
              <v-row>
                <v-col class="pb-0 pt-0">
                  <v-text-field v-if="!view"
                    light dense outlined
                    :value="balances.Available != null? (Number(balances.Available) - Number(currentPurchase.InstrumentValue)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                    color="#2A353D"
                    label="Available Balance"
                    readonly class="pb-0"
                    placeholder="----"
                    :prefix="Currency[0].CurrencySymbol"
                  ></v-text-field>
                  <v-text-field v-else
                    light dense outlined
                    v-model="currentPurchase.AvailAtTxn"
                    color="#2A353D"
                    label="Available Balance"
                    readonly class="pb-0"
                    placeholder="----"
                    :prefix="Currency[0].CurrencySymbol"
                  ></v-text-field>
                </v-col>
                <v-col class="pb-0 pt-0">
                  <v-text-field v-if="!view"
                    light dense outlined
                    :value="balances.Actual != null? Number(balances.Actual).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                    color="#2A353D"
                    label="Actual Balance"
                    readonly
                    placeholder="----"
                    :prefix="Currency[0].CurrencySymbol"
                  ></v-text-field>
                  <v-text-field v-else
                    light dense outlined
                    v-model="currentPurchase.ActualAtTxn"
                    color="#2A353D"
                    label="Actual Balance"
                    readonly
                    placeholder="----"
                    :prefix="Currency[0].CurrencySymbol"
                  ></v-text-field>
                </v-col>
              </v-row>
                <v-text-field
                  light dense outlined
                  color="#2A353D"
                  v-model="currentPurchase.InstrumentValue"
                  @input="GetGrossInterest(currentPurchase, currentPurchase.PurchaseDate)"
                  label="Nominal Amount"
                  required
                  type="number"
                  :readonly="view"
                  :rules="[
                    v => !!v || 'field is required',
                    v =>  v <= Number(balances.Available) || 'Amount exceeds Available balance',
                  ]"
                  placeholder="----"
                ></v-text-field>
                <v-select
                  outlined dense
                  v-model="currentPurchase.SellerID"
                  :items="allCounterparties.filter(a => a.IsSeller == true && a.CheckerID != 0 && a.RejectionID == 0)"
                  item-text="CounterPartyName"
                  item-value="CounterPartyID"
                  placeholder="----"
                  :readonly="view"
                  :rules="TextFieldRules"
                  label="Counterparty"
                ></v-select>
                <v-row>
                  <v-col class="pb-0 pt-0">
                    <v-text-field
                      light dense outlined
                      color="#2A353D"
                      :disabled="!currentPurchase.IsTaxable"
                      @input="getWith_holdingTax(currentPurchase)"
                      v-model="currentPurchase.TaxRate"
                      label="Tax Rate"
                      readonly
                      required
                      type="number"
                      placeholder="----"
                      suffix="%"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="pb-0 pt-0">
                    <v-text-field
                      light dense outlined
                      color="#2A353D"
                      :value="currentPurchase.PurchaseDate != null && MaturityDate != null && currentPurchase.Rate != null && currentPurchase.InstrumentValue != null ? GrossInterest : ''"
                      label="Gross Interest"
                      required
                      readonly
                      :rules="TextFieldRules"
                      placeholder="----"
                      :prefix="Currency[0].CurrencySymbol"
                    ></v-text-field>
                  </v-col>
                  <v-col class="pb-0 pt-0">
                    <v-text-field
                      light dense outlined
                      color="#2A353D"
                      :disabled="!currentPurchase.IsTaxable"
                      :value="(Number(GrossInterest) * (Number(currentPurchase.TaxRate) / 100)).toFixed(2)"
                      label="With-holding Tax"
                      required
                      readonly
                      :rules="TextFieldRules"
                      placeholder="----"
                      :prefix="Currency[0].CurrencySymbol"
                    ></v-text-field>
                  </v-col>
                </v-row>
            </v-col>
            <v-col class="pb-0">

              <v-text-field
                v-model="currentPurchase.PurchaseDate"
                label="Purchase Date"
                append-icon="mdi-calendar-month"
                readonly placeholder="--/--/--"
                dense outlined color="#2A353D"
              ></v-text-field>

              <v-row>
                <v-col class="pb-0 pt-0">
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    @input="getMaturityDate(currentPurchase.PurchaseDate)"
                    v-model="TenorDays"
                    label="Tenor Days"
                    type="number"
                    :readonly="view"
                    placeholder="----"
                    :rules="[
                      v => !!v || 'field is required',
                      v => v > 0 || 'Tenor should be > 0'
                    ]"
                  ></v-text-field>
                </v-col>
                <v-col class="pb-0 pt-0">
                  <v-text-field v-if="view"
                    v-model="currentPurchase.MaturityDate"
                    label="Maturity Date"
                    append-icon="mdi-calendar-month"
                    readonly placeholder="--/--/--"
                    dense outlined color="#2A353D"
                    :rules="TextFieldRules"
                  ></v-text-field>
                  <v-menu v-else
                    ref="menu_2"
                    v-model="menu_2"
                    :close-on-content-click="false"
                    :return-value.sync="MaturityDate"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="MaturityDate"
                        label="Maturity Date"
                        append-icon="mdi-calendar-month"
                        readonly placeholder="--/--/--"
                        dense outlined color="#2A353D"
                        :disabled="view"
                        :error-messages="errors"
                        :rules="EditDateRules"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker @change="getTenorDays(currentPurchase.PurchaseDate)" color="#2A353D" v-model="MaturityDate" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn outlined small color="#2A353D" @click="menu_2 = false">Cancel</v-btn>
                    <v-btn outlined small color="#2A353D" @click="$refs.menu_2.save(MaturityDate)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>

              <v-select
                outlined dense
                @change="currentPurchase.IsTaxable == true ? currentPurchase.TaxRate = allInstrumentTypes.filter(a => a.InstrumentTypeID == currentPurchase.InstrumentID).map(a => a.DefaultTaxRate)[0] : ''"
                v-model="currentPurchase.InstrumentID"
                :items="allInstrumentTypes.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                item-text="InstrumentTypeCode"
                item-value="InstrumentTypeID"
                placeholder="----"
                :readonly="view"
                :rules="TextFieldRules"
                label="Instrument"
              ></v-select>

              <v-text-field
                light dense outlined
                color="#2A353D"
                v-model="currentPurchase.BrokerNote"
                label="Deal Note"
                readonly
                placeholder="----"
              ></v-text-field>

              <v-row>
                <v-col class="pb-0 pt-0">
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    @input="GetGrossInterest(currentPurchase, currentPurchase.PurchaseDate)"
                    v-model="currentPurchase.Rate"
                    label="Deal Rate"
                    type="number"
                    placeholder="----"
                    :rules="TextFieldRules"
                    :readonly="view"
                    suffix="%"
                  ></v-text-field>
                </v-col>
                <!-- <v-col class="pb-0 pt-0">
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    @input="GetGrossInterest(currentPurchase, currentPurchase.PurchaseDate)"
                    v-model="currentPurchase.Rate"
                    label="Client Rate"
                    type="number"
                    placeholder="----"
                    :rules="TextFieldRules"
                    :readonly="view"
                    suffix="%"
                  ></v-text-field>
                </v-col> -->
              </v-row>

              <v-row>
                <v-col class="pb-0 pt-0">
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    :value="currentPurchase.TaxRate != null && GrossInterest != null? Number(Number(GrossInterest) - (Number(GrossInterest) * (Number(currentPurchase.TaxRate) / 100))).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                    label="Net Interest"
                    readonly
                    placeholder="----"
                    :prefix="Currency[0].CurrencySymbol"
                  ></v-text-field>
                </v-col>
                <v-col class="pb-0 pt-0">
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    :value="currentPurchase.TaxRate != null && GrossInterest != null ? Number(Number(currentPurchase.InstrumentValue) + (Number(GrossInterest) - (Number(GrossInterest) * (Number(currentPurchase.TaxRate) / 100)))).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                    label="Maturity Value"
                    readonly placeholder="----"
                    :prefix="Currency[0].CurrencySymbol"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-data-table
      :headers="allocations_headers"
      :fixed-header="true"
      :items="currentPurchase.allocations.filter(c => c.FldBit02 == 0)"
      disable-pagination
      hide-default-footer dense
      class="elevation-12 my-allocations-table mt-3"
    >

      <template v-slot:top >
        <v-toolbar dense flat>
          <v-toolbar-title class="grey--text caption font-weight-normal">Allocations</v-toolbar-title>
          <v-spacer/>
          <v-btn v-if="!view" class="text-right" @click="NewAllocation(currentPurchase.allocations)" x-small dark outlined fab color="#2A353D">
            <v-icon small >mdi-plus</v-icon>
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.AccountID="{ item }">
        <v-select
          @change="getCurrentAccountBalance(item)"
          @click="setActiveAllocation(item, index)"
          background-color="#ffffff00"
          v-model="item.AccountID"
          :items="Accounts"
          :menu-props="{ top: true, offsetY: true }"
          item-text="AccountName"
          item-value="AccountID"
          solo flat class="Account ma-0 pa-0 pt-5"
          placeholder="----" dense
          :rules="[
            v => !!v || 'field is required',
            v => currentPurchase.allocations.filter(a => a.FldBit02 == 0 && a.AccountID == item.AccountID).length < 2 || 'Account already selected'
          ]"
        ></v-select>
      </template>

      <template v-slot:item.OpeningBalance="{ item }">
        <span v-if="!view">{{Number(item.OpeningBalance).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
        <span v-else>{{Number(item.OpeningBalance).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
      </template>

      <template v-slot:item.AllocationRate="{ item }">
        {{Number(getAllocationRate(item, currentPurchase)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
      </template>

      <template v-slot:item.FldNum03="{ item }">
        <span v-if="!view">{{Number(getCharges(item, currentPurchase)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 3})}}</span>
        <span v-else>{{Number(item.FldNum03).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
      </template>

      <template v-slot:item.FldNum02="{ item }">
        <span v-if="!view">{{Number(getInterest(item, currentPurchase)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
        <span v-else>{{Number(item.FldNum02).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
      </template>

      <template v-slot:item.FldNum01="{ item }">
        <span v-if="!view">{{Number(getMaturityValue(item)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
        <span v-else>{{Number(item.FldNum01).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
      </template>

      <template  v-slot:item.AllocationValue="{ item }">
        <v-text-field
          v-model="item.AllocationValue"
          :rules="view ? [] : item.OpeningBalance != null ? [
            v => !!v || 'field is required',
            v =>  v <= Number(item.OpeningBalance) || 'Over allocated',
          ] : []"
          label="Amount"
          @keydown="getNetValueValidation(currentPurchase.allocations, item)"
          single-line
          :readonly="view"
          type="number"
        ></v-text-field>
      </template>

      <template v-slot:item.action="{ item }">
        <v-icon v-if="!view" small @click="removeAllocation(item, currentPurchase.allocations)">mdi-close</v-icon>
      </template>

      <template v-slot:footer >
        <v-divider class="mt-0"/>
        <v-row class="ml-2 mr-2">
          <v-col class="pb-0 pt-7" cols="2">
          <v-text-field
            class="table-text-field"
            light dense
            :value="Number(getAllocatedValue(currentPurchase.allocations.filter(c => c.FldBit02 == 0))).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})"
            color="#2A353D"
            label="Allocated Value"
            readonly
            :rules="[() => getAllocatedValue(currentPurchase.allocations.filter(c => c.FldBit02 == 0)) == currentPurchase.InstrumentValue || 'should match Deal Value']"
            :prefix="Currency[0].CurrencySymbol"
          ></v-text-field>
          </v-col>
          <v-col class="pb-0 pt-7">
          <v-text-field
            class="table-text-field"
            light dense
            :value="Number(getAllocatedUnits(currentPurchase.allocations.filter(c => c.FldBit02 == 0))).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})"
            color="#2A353D"
            label="Total Maturity"
            readonly
            :rules="[() => Number(getAllocatedUnits(currentPurchase.allocations.filter(c => c.FldBit02 == 0))).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) == Number(Number(currentPurchase.InstrumentValue) + (Number(GrossInterest) - (Number(GrossInterest) * (Number(currentPurchase.TaxRate) / 100)))).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) || 'should match Maturity Value']"
          ></v-text-field>
          </v-col>
          <v-col class="pb-0 pt-7">
          <v-text-field
            class="table-text-field"
            light dense
            :value="currentPurchase.InstrumentValue != null ? Number(currentPurchase.InstrumentValue - getAllocatedValue(currentPurchase.allocations.filter(c => c.FldBit02 == 0))).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : 0"
            color="#2A353D"
            label="Remaining Amount"
            readonly
          ></v-text-field>
          </v-col>
          <v-col class="pb-0 pt-7" cols="6">
            <div class="text-right mb-4 mt-4">
              <v-btn class="white--text" small color="#2A353D" @click="view = false; closeEdit()">close</v-btn>
              <v-btn class="white--text ml-4" v-if="!view" small color="#2A353D" :disabled="!valid || loading == true" @click="update()">
                <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                save
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </template>
    </v-data-table>
  </v-form>
<!-- ********************************************************************************************TABLE**************************************************************************************************
***************************************************************************************************************************************************************************************************** -->

  <v-data-table
    disable-pagination
    hide-default-footer
    :height="520"
    :headers="headers"
    :fixed-header="true"
    :items="confirmedPurchases ? Purchases : Purchases.filter(a => a.CheckerID === 0)"
    :search="search" v-if="!create &&  !edit"
    sort-by="MakeDate"
    sort-desc
    class="elevation-12 mt-2"
    @current-items="getFiltered"
  >

    <template v-slot:top >
      <v-dialog persistent v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="subtitle-1 grey--text">Choose a reason for this rejection</span>
          </v-card-title>

          <v-card-text>
            <v-select
              filled dense
              v-model="RejectionStatus"
              :items="allRejectionReasons.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
              item-text="RejectionReasonDescription"
              item-value="RejectionReasonID"
              label="Rejection Reasons"
            ></v-select>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="text-right mb-4">
              <v-btn class="white--text mr-3" small color="#2A353D" @click="close()">cancel</v-btn>
              <v-btn class="white--text mr-3" small color="#2A353D" v-if="RejectionStatus !== 0" @click="updateStatus('', false); close()">
                <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                ok
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="reverseDialog" max-width="500px">
        <v-form flat ref="form" v-model="valid" lazy-validation>
          <v-card>
            <v-card-title>
              <span class="grey--text text-center">Deal Reversal</span>
            </v-card-title>

            <v-card-text>
              <span class="subtitle-1">{{reversal_description}}</span>

              <v-textarea
                class="mt-3"
                label="Reversal Reason"
                v-model="ReversalReason"
                outlined rows="6"
                row-height="15"
                :rules="TextFieldRules"
                placeholder="----"
              ></v-textarea>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <div class="text-right mb-4">
                <v-btn class="white--text mr-3" small color="#2A353D" @click="reverseDialog = false">cancel</v-btn>
                <v-btn class="white--text mr-3" small color="#2A353D" :disabled="!valid" @click="ReverseDeal()">
                  <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                  submit
                </v-btn>
              </div>
            </v-card-actions>
          </v-card>          
        </v-form>
      </v-dialog>

      <v-dialog v-if="currentPurchase" persistent v-model="DealNoteDialog" max-width="900px">
        {{DealNote}}
        <v-card flat height="640" class="mt-0">
          <v-toolbar dense flat tile color="#2A353D">
            <v-toolbar-title class="white--text subtitle-1 font-weight-normal">Deal Confirmation</v-toolbar-title>
            <v-spacer/>
            <v-btn fab x-small outlined color="#81DBF6" @click="DealNoteDialog = false; DealNote = []; DealNoteAccountID = 0; DealNoteUri = ''; CustDealNote = []; CustDealNoteUri = ''"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-tabs
              v-model="tab"
              dark center-active
              background-color= "#2A353D"
              height = "40px" class="mb-0"
              slider-size = "4"
          >
            <v-tabs-slider color="#81DBF6"></v-tabs-slider>

            <v-tab>
                <h6 class="caption text-capitalize font-weight-normal">Custodian</h6>
            </v-tab>
            <v-tab>
                <h6 class="caption text-capitalize font-weight-normal">Clients</h6>
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-sheet class="mx-4 mt-3" min-height="520px" color="grey">
                <iframe :src="CustDealNoteUri" width="100%" height="520px"></iframe>
              </v-sheet>
            </v-tab-item>
            <v-tab-item>
              <v-toolbar color="white" dark dense flat>
                <v-select
                  @change="getDealNote()"
                  v-model="DealNoteAccountID"
                  :items="Accounts.filter(a => currentPurchase.allocations.map(c => c.AccountID).includes(a.AccountID))"
                  item-text="AccountName"
                  item-value="AccountID"
                  label="Account" class="mt-5"
                  hide-details dense light
                  placeholder="----"
                ></v-select>

                <v-spacer/>
                <v-btn class="mx-2" outlined small color="#2A353D" v-on="on">
                  MAIL<v-icon small>mdi-email</v-icon>
                </v-btn>
              </v-toolbar>
              <v-sheet class="mx-4 mt-3" min-height="470px" color="grey">
                <iframe :src="DealNoteUri" width="100%" height="470px"></iframe>
              </v-sheet> 
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-dialog>

      <v-container row>

        <v-text-field
          class="ml-3"
          hide-details
          outlined
          placeholder="search..."
          v-model="search"
          append-icon="mdi-magnify"
          dense
        ></v-text-field>

        <v-spacer></v-spacer>

        <v-btn v-if="showCreateBtn == true && DealerID > 0" v-show="confirmedPurchases" @click="overlay = true; showCreate(); closeEdit()" outlined small color="#2A353D" class="ml-2">
          Create New<v-icon small>mdi-plus</v-icon>
        </v-btn>
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" v-show="confirmedPurchases" outlined small color="#2A353D" class="ml-2">
            EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
          </v-btn>
          </template>
          <v-list dense>
          <v-list-item class="ma-0 pa-0">
            <v-btn @click="generatePDF(false)" text small color="#2A353D">
              <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentDataset"
                type    = "xls"
                name    = "MM Purchases.xls">
  
                <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
              </download-excel>
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentDataset"
                type    = "csv"
                name    = "MM Purchases.csv">
  
                <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
              </download-excel>
            </v-btn>
          </v-list-item>
          </v-list>
        </v-menu>
        <v-btn @click="generatePDF(true)" v-show="confirmedPurchases" outlined small color="#2A353D" class="ml-2" v-on="on">
          PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
        </v-btn>
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" outlined small color="#2A353D" class="ml-2">
            CURRENCY<v-icon class="ml-1">mdi-cash-check</v-icon>
          </v-btn>
          </template>
          <v-list dense>
          <v-list-item v-for="Currency in allCurrencies.filter(a => a.CheckerID != 0 && a.RejectionID == 0)" :key="Currency.CurrencyID" @click="mapCurrency(Currency); getCustodians(); __getInterestDenominator()">

          <v-list-item-title>
            {{ Currency.CurrencyName }}
          </v-list-item-title>

          </v-list-item>
          </v-list>
        </v-menu>
        <v-btn v-show="!confirmedPurchases" @click="confirmedPurchases = true" outlined small color="#2A353D" class="ml-2" v-on="on">
          ALL RECORDS<v-icon class="ml-1">mdi-playlist-check</v-icon>
        </v-btn>
      </v-container>
    </template>

    <template v-slot:item.status="{ item }">
      <v-chip outlined small color="error" v-if="item.RejectionID !== 0 && item.IsReversed == 0">rejected</v-chip>
      <v-chip outlined small color="error" v-if="item.IsReversed == 1">reversed</v-chip>
      <v-chip outlined small color="warning" v-if="item.CheckerID == 0 && item.IsReversed == 0">pending</v-chip>
      <v-chip outlined dark small color="#A6D879" v-if="item.CheckerID !== 0 && item.RejectionID == 0 && item.IsReversed == 0">confirmed</v-chip>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-tooltip v-if="!confirmedPurchases && item.CheckerID == 0" top>
        <template v-slot:activator="{ on }">
        <v-btn
          small @click="updateStatus(item, true)"
          outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
          v-on="on"
          color="#2A353D" class="mr-3"
        >
          confirm<v-icon class="ml-1" color="#2A353D">mdi-check-circle-outline</v-icon>
        </v-btn>
        </template>
        <span>confirm</span>
      </v-tooltip>
      <v-tooltip v-if="!confirmedPurchases && item.CheckerID == 0" top>
        <template v-slot:activator="{ on }">
        <v-btn
          small @click="reject(); setActivePurchase(item, index)"
          outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
          v-on="on"
          color="#2A353D" class="mr-3"
        >
          reject<v-icon class="ml-1" color="#2A353D">mdi-close-circle-outline</v-icon>
        </v-btn>
        </template>
        <span>reject</span>
      </v-tooltip>
      <v-btn
        v-show="confirmedPurchases && DealerID > 0"
        small outlined v-if="item.CheckerID == 0? item.MakerID == currentUser.SecurityUserID : showEditBtn == true"
        @click="setActivePurchase(item, index); showEdit(); closeCreate()"
        color="#2A353D" class="mr-3"
      >
        <span>edit</span>
      </v-btn>
      <v-btn
        small outlined
        @click="view = true; setActivePurchase(item, index); showEdit(); closeCreate()"
        color="#2A353D" class="mr-3"
      >
        <span>view</span>
      </v-btn>
      <v-btn
        v-show="confirmedPurchases"
        small outlined v-if="item.CheckerID == 0? item.MakerID == currentUser.SecurityUserID : showEditBtn == true"
        @click="setActivePurchase(item, index); getCustDealNote(item); DealNoteDialog = true"
        color="#2A353D" class="mr-3"
      >
        <span>receipt</span>
      </v-btn>
      <v-tooltip v-show="confirmedPurchases" top>
        <template v-slot:activator="{ on }">
          <v-icon
            v-on="on"
            :disabled="showReverseBtn == true && item.CheckerID == 0 ? false : true"
            color="#2A353D" @click="setActivePurchase(item, index); initReversal(item)"
          >
          mdi-backup-restore
          </v-icon>
        </template>
        <span>reverse</span>
      </v-tooltip>
    </template>

    <template v-slot:item.CustodialID="{ item }">
      {{getCustodianName(item.CustodialID)}}
    </template>

    <template v-slot:item.AccountID="{ item }">
      {{getAccountName(item.AccountID)}}
    </template>

    <template v-slot:item.PurchaseDate="{ item }">
      {{ item.PurchaseDate | moment("DD MMM YYYY") }}
    </template> 

    <!-- <template v-slot:item.ValueDate="{ item }">
      {{ item.ValueDate | moment("DD MMM YYYY") }}
    </template>  -->

    <!-- <template v-slot:item.MakeDate="{ item }">
      {{ item.MakeDate | moment("DD MMMM YYYY") }}
    </template> -->

  </v-data-table>
</v-container>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import UserService from '../services/user.service';
import dealingService from '../services/dealing.service';
import transactionService from '../services/transaction.service';
import administrationService from '../services/administration.service';
import jsPDF from 'jspdf';
import 'jspdf-autotable'

export default {
  data () {
    return {
      confirmedPurchases: true,
      edit: false,
      create:false,
      view: false,
      dialog: false,
      reverseDialog: false,
      ReversalReason: '',
      reversal_description: '',
      DealNote: [],
      DealNoteAllocationNo: null,
      DealNoteDialog: false,
      DealNoteUri: '',
      CustDealNote: [],
      DealNoteRef: null,
      CustDealNoteUri: '',
      CustContact: null,
      tab: null,
      Contacts: null,
      permitted: null,
      permitted_dialog: true,
      message: '',
      TenorDays: 0,
      MaturityDate: '',
      menu: false,
      menu_1: false,
      menu_2: false,
      loading: false,
      search: '',
      valid: true,
      currentAllocation: null,
      allocationIndex: -1,
      currentPurchase: null,
      currentIndex: -1,
      CurrentDataset: [],
      headers: [
        {
          text: 'Deal Note',
          align: 'start',
          sortable: true,
          value: 'BrokerNote'
        },
        { text: 'Custodian', value: 'CustodialID', sortable: true },
        // { text: 'Purchase Date', value: 'PurchaseDate', sortable: true },
        // { text: 'Value Date', value: 'ValueDate', sortable: true },
        // { text: 'Deposit Method', value: 'DepositMethodID', sortable: true },
        // { text: 'Date Created', value: 'MakeDate', sortable: true },
        { text: 'Status', value: 'status', sortable: false },
        { value: 'actions', sortable: false, align: 'end' },
      ],
      TextFieldRules: [
        v => !!v || 'field is required',
      ],
      CreateDateRules: [
        v => !!v || 'field is required',
        v => (v >= this.currentSystemDate.DayDate) || 'Deal cannot mature before Purchase Date'
      ],
      EditDateRules: [
        v => !!v || 'field is required',
        v => (v >= this.currentPurchase.PurchaseDate) || 'Deal cannot mature before Purchase Date'
      ],
      AllocatedValueRules: [
        v => !!v || 'field is required',
        v => (!!v && v == Number(this.MMPurchase.purchase.InstrumentValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})) || 'should match Deal Value',
      ],
      AllocatedUnitsRules: [
        v => !!v || 'field is required',
        v => (!!v && v == Number(Number(this.MMPurchase.purchase.InstrumentValue) + (Number(this.GrossInterest) - (Number(this.GrossInterest) * (Number(this.MMPurchase.purchase.TaxRate) / 100)))).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})) || 'should match Maturity Value'
      ],
      EditAllocatedValueRules: [
        v => !!v || 'field is required',
        v => (!!v && v == Number(this.currentPurchase.InstrumentValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})) || 'should match Deal Value',
      ],
      EditAllocatedUnitsRules: [
        v => !!v || 'field is required',
        v => (!!v && v == Number(Number(this.currentPurchase.InstrumentValue) + (Number(this.GrossInterest) - (Number(this.GrossInterest) * (Number(this.currentPurchase.TaxRate) / 100)))).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})) || 'should match Deal Quantity',
      ],
      allocations_headers: [
        { text: 'Account Name', value: 'AccountID', sortable: false, width: 200 },
        { text: 'Amount', value: 'AllocationValue', sortable: false, width: 170},
        { text: 'O/Balance', value: 'OpeningBalance', sortable: false, width: 170 },
        { text: 'Rate %', value: 'AllocationRate', sortable: false },
        { text: 'Charges', value: 'FldNum03', sortable: false },
        { text: 'Interest', value: 'FldNum02',  sortable: false },
        { text: 'Maturity Value', value: 'FldNum01',  sortable: false },
        { value: 'action', sortable: false }
      ],
      balances: {},
      Taxable: false,
      CurrencyId: 0,
      DealCustodians: [],
      Accounts: [],
      Basis: [],
      WithHoldingTax: 0,
      GrossInterest: 0,
      TotalValue: 0,
      RejectionStatus: 0,
      DealNoteAccountID: 0,
      InterestDenominator: 0,
      MMPurchase: {
        purchase: {
          InstrumentValue: 0
        },
        allocation: []
      },
      errors: [],
      BlockingViolation: null,
      BNerrors: [],
      toggle_exclusive: undefined,
    }
  },

  computed: {
    ...mapGetters([
      "currentImage",
      "identity",
      "allCountries",
      "allClientAccounts",
      "allCities",
      "allInstrumentTypes",
      "allApplicationDefaults",
      "allMMPurchases",
      "allCurrencies",
      "allRejectionReasons",
      "allCounterparties",
      "allDealers",
      "allUsers",
      "currentSystemDate",
      "allConfirmationSettings"
    ]),

    IsDiscount(){
      return this.CheckDiscountStatus()
    },

    currentUser() {
      return this.$store.state.auth.user;
    },
    Purchases() {
      return this.allMMPurchases.filter(a => a.CurrencyID == this.CurrencyId);
    },
    Currency() {
      return this.allCurrencies.filter(a => a.CurrencyID == this.CurrencyId && a.CheckerID != 0 && a.RejectionID == 0);
    },
    DealerID() {
      return this.allDealers.filter(a => a.SystemUserID == this.currentUser.SecurityUserID).map(a => a.DealerID).toLocaleString();
    },
    showEditBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 103).map(r => r.AllowEdit)) == 1){
        return true
      }
    }
    return false;
    },

    showCreateBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 103).map(r => r.AllowCreate)) == 1){
        return true
      }
    }
    return false;
    },

    showConfirmBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 103).map(r => r.AllowConfirm)) == 1){
        return true
      }
    }
    return false;
    },

    showReverseBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 103).map(r => r.AllowReversal)) == 1){
        return true
      }
    }
    return false;
    },

    CheckerID(){
      if(this.allConfirmationSettings.filter(a => a.FunctionID == 103).map(a => a.Status)[0] == false){
        return this.currentUser.SecurityUserID
      } else {
        return 0
      }
    }
  },

  watch: {
    MaturityDate: function(newValue) {
      if(newValue != null && newValue != ''){
        if(this.edit == true){
          this.GetGrossInterest(this.currentPurchase, this.currentPurchase.PurchaseDate)
        } else{
          this.GetGrossInterest(this.MMPurchase.purchase, this.currentSystemDate.DayDate)
        }

        var data = {
          Date: newValue,
        };

        dealingService.checkIsWeekendHoliday(data)
        .then(response => {
          this.errors = response.data[0].Valid ? ['Date cannot be a weekend or holiday'] : []
        })        
      }
    },

    InterestDenominator: function(newValue) {
      if(newValue > 0){
        if(this.edit == true){
          this.GetGrossInterest(this.currentPurchase, this.currentPurchase.PurchaseDate)
        } else{
          this.GetGrossInterest(this.MMPurchase.purchase, this.currentSystemDate.DayDate)
        }  
      }
    },

    DealNoteAccountID: function(newValue) {
      if(newValue != null && newValue != 0){
        // this.generateDealNote(false)
        // this.DealNoteDialog = false     
      }
    },

    'MMPurchase.purchase.BrokerNote': {
      handler: function(newValue) {
        if(newValue != null && newValue != ''){
          var data = {
            BrokerNote: newValue,
          };

          dealingService.checkBrokerNoteIsUnique(data)
          .then(response => {
            this.BNerrors = response.data[0].IsUnique ? [] : ['Deal Note already in use']
          })
        }
      },
      deep: true
    },

    'MMPurchase.purchase.TaxRate': {
      handler: function() {
        if (this.Taxable == true){
          this.getWith_holdingTax(this.MMPurchase.purchase)
        }
      },
      deep: true
    },

    'currentPurchase.TaxRate': {
      handler: function() {
        if (this.Taxable == true){
          this.getWith_holdingTax(this.currentPurchase)
        }
      },
      deep: true
    },

    'currentPurchase.IsTaxable': {
      handler: async function(newValue) {
        this.Taxable = newValue;
        this.getAccounts(this.currentPurchase.CustodialID)
      },
      deep: true
    },

    'currentPurchase.PurchaseID': {
      handler: async function() {
        // this.currentPurchase.Quantity = Number(this.currentPurchase.Quantity.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0}))
        this.getWith_holdingTax(this.currentPurchase)
        this.MaturityDate = this.currentPurchase.MaturityDate;
        this.Taxable = !!this.currentPurchase.IsTaxable;
        this.getTenorDays(this.currentPurchase.PurchaseDate);
        this.GetGrossInterest(this.currentPurchase, this.currentPurchase.PurchaseDate)

        // if(this.view != true){
        //   for (let i = 0; i < this.currentPurchase.allocations.length; i++) {
        //     this.getCurrentAccountBalance(this.currentPurchase.allocations[i])
        //   }
        // }

        // for (let t = 0; t < this.currentPurchase.allocations.length; t++) {
        //   this.currentPurchase.allocations[t].Quantity = Number(this.currentPurchase.allocations[t].Quantity.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0}))
        // }
      },
      deep: true
    }
    // Taxable: function(newValue){
    //   if(newValue == false){
    //     this.MMPurchase.purchase.TaxRate = 0;
    //     this.currentPurchase.TaxRate = 0
    //   }
    // }
  },

  created () {
    this.CurrencyId = this.allApplicationDefaults[0].CurrencyID;
    this.getCustodians();
    this.getBasis();
    this.__getInterestDenominator();
  },

  methods: {
    ...mapActions([
      "createPurchase",
      "updatePurchase",
      "updatePurchaseStatus",
      "createReversal"
    ]),

     async createNew() {
      this.message = '';

      await this.validate()

      if (this.valid == true) {
        this.loading = true;
        this.MMPurchase.purchase.FldNum01 = Number(this.GrossInterest) - (Number(this.GrossInterest) * (Number(this.MMPurchase.purchase.TaxRate) / 100)),
        this.MMPurchase.purchase.FldNum02 = Number(this.MMPurchase.purchase.InstrumentValue) + (Number(this.GrossInterest) - (Number(this.GrossInterest) * (Number(this.MMPurchase.purchase.TaxRate) / 100))),
        this.MMPurchase.purchase.MakerID = this.currentUser.SecurityUserID,
        this.MMPurchase.purchase.CheckerID = this.CheckerID,
        this.MMPurchase.purchase.PurchaseDate = this.currentSystemDate.DayDate,
        this.MMPurchase.purchase.SettlementDate = this.currentSystemDate.DayDate,
        this.MMPurchase.purchase.MaturityDate = this.MaturityDate,
        this.MMPurchase.purchase.AllocationType = 1,
        this.MMPurchase.purchase.Tax = this.WithHoldingTax,
        this.MMPurchase.purchase.IsTaxable = this.Taxable,
        this.MMPurchase.purchase.CurrencyID = this.CurrencyId,
        this.MMPurchase.purchase.DealerID = this.DealerID,
        this.MMPurchase.purchase.LastUserID = this.currentUser.SecurityUserID,
        this.MMPurchase.purchase.AssetType = 4,
        this.MMPurchase.purchase.AvailAtTxn = Number(this.balances.Available) - Number(this.MMPurchase.purchase.InstrumentValue),
        this.MMPurchase.purchase.ActualAtTxn = this.balances.Actual,
        this.MMPurchase.purchase.FldBit01 = 1,

        this.MMPurchase.charges = [],
        this.MMPurchase.taxes = [],

        this.createPurchase(this.MMPurchase)
        .then(response =>{
          this.$socket.client.emit('socketreq', {
            commit: 'newPurchase',
            data: response.data
          });
          this.message = response.data.message
          this.loading = false;
          this.closeCreate()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false;
        })
      }
    },

    async update() {
      this.message = '';

      await this.validate()

      if (this.valid == true) {
        this.loading = true;
        this.currentPurchase.FldNum01 = Number(this.GrossInterest) - (Number(this.GrossInterest) * (Number(this.currentPurchase.TaxRate) / 100)), //Accrued Interest
        this.currentPurchase.FldNum02 = Number(this.currentPurchase.InstrumentValue) + (Number(this.GrossInterest) - (Number(this.GrossInterest) * (Number(this.currentPurchase.TaxRate) / 100))), //Maturity Value
        this.currentPurchase.AvailAtTxn = Number(this.balances.Available) - Number(this.currentPurchase.InstrumentValue),
        this.currentPurchase.ActualAtTxn = this.balances.Actual,
        this.currentPurchase.MakerID = this.currentUser.SecurityUserID,
        this.currentPurchase.CurrencyID = this.CurrencyId,
        this.currentPurchase.DealerID = this.DealerID,
        this.currentPurchase.MaturityDate = this.MaturityDate,
        this.currentPurchase.LastUserID = this.currentUser.SecurityUserID,
        this.currentPurchase.AllocationType = 1,
        this.currentPurchase.Tax = (this.GrossInterest) * (this.currentPurchase.TaxRate / 100),
        this.currentPurchase.CheckerID = 0,
        this.currentPurchase.CheckDate = null,
        this.currentPurchase.MakeDate = new Date(),
        this.currentPurchase.RejectionID = this.RejectionStatus,

        this.updatePurchase(this.currentPurchase)
        .then(response => {
          this.$socket.client.emit('socketreq', {
            commit: 'updPurchase',
            data: this.currentPurchase
          });

          this.message = response.data.message
          this.loading = false;
          this.closeEdit()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false;
        })
      }
    },

    updateStatus(item, status) {
      this.message = '';
      this.loading = true;

      if(status == true){
        item.CheckerID = this.currentUser.SecurityUserID,
        item.LastUserID = this.currentUser.SecurityUserID,
        item.CheckDate = new Date(),
        item.updatedAt = new Date(),
        item.RejectionID = this.RejectionStatus,
        item.IsConfirmation = status,

        this.updatePurchaseStatus(item)
        .then(response => {
          this.$socket.client.emit('socketreq', {
            commit: 'updPurchase',
            data: item
          });

          this.message = response.data.message
          this.loading = false;
          this.closeEdit()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false;
        }) 
      } else {
        this.currentPurchase.CheckerID = this.currentUser.SecurityUserID,
        this.currentPurchase.LastUserID = this.currentUser.SecurityUserID,
        this.currentPurchase.CheckDate = new Date(),
        this.currentPurchase.updatedAt = new Date(),
        this.currentPurchase.RejectionID = this.RejectionStatus,
        this.currentPurchase.IsConfirmation = status,

        this.updatePurchaseStatus(this.currentPurchase)
        .then(response => {
          this.$socket.client.emit('socketreq', {
            commit: 'updPurchase',
            data: this.currentPurchase
          });

          this.message = response.data.message
          this.loading = false;
          this.closeEdit()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false;
        })        
      }
    },

    initReversal(item){
      var data = {
        FunctionID: 103,
        EntryID: item.PurchaseID,
        ReversalDate: this.currentSystemDate.DayDate
      }

      dealingService.initReversal(data)
      .then(response => {
        if(response.data.validation[0].fnResultClass == 1){
          this.reverseDialog = true
          this.reversal_description = response.data.description[0][0].description
        } else {
          this.message = response.data.validation[0].fnResult
        }
      })
    },

    async ReverseDeal(){
      this.message = '';
      await this.validate()

      if (this.valid == true) {
        var data = {
          ReversalID: 0,
          FunctionID: 103,
          EntityID: this.currentPurchase.PurchaseID,
          ReversalReason: this.ReversalReason,
          ReversalDate: this.currentSystemDate.DayDate,
          MakerID: this.currentUser.SecurityUserID,
          CheckerID: 0,
          LastUserID: this.currentUser.SecurityUserID,
          RejectionID: 0,
        }

        this.createReversal(data)
        .then(response => {
          this.$socket.client.emit('socketreq', {
            commit: 'newReversal',
            data: response.data
          });

          this.message = response.data.message
          this.loading = false;
          this.reverseDialog = false;
          this.reversal_description = '';
          this.ReversalReason = '';
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false;
        })
      }
    },

    getBasis() {
      this.message = '';
      dealingService.getDayCountBasis()
      .then(response => {
        this.Basis = response.data
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })
    },

    getCustodians() {
      this.message = '';
      var data ={
        CurrencyID: this.CurrencyId,
      }
      dealingService.getCustodians(data.CurrencyID)
      .then(response => {
        this.DealCustodians = response.data
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })
    },

    getDealNote() {
      this.message = '';
      this.DealNote = [];
      this.DealNoteAllocationNo = null;

      var data = {
        AllocationID: this.currentPurchase.allocations.filter(c => c.AccountID == this.DealNoteAccountID).map(c => c.PurchaseAllocationID)[0],
        AccountID: this.DealNoteAccountID
      }

      dealingService.getDealNote(data.AllocationID, data)
      .then(response => {
        this.Contacts = response.data.contacts[0];
        this.DealNoteAllocationNo = response.data.data[0].ReferenceNo;
        const { PurchaseAllocationID, ReferenceNo, Instrument,  ValueDate, Currency, PrincipalAmount, Tenor, InterestRate, InterestAmount, MaturityDate, MaturityAmount } = response.data.data[0]

        const TitleList = ['PurchaseAllocationID', 'ReferenceNo', 'Instrument', 'Value Date', 'Currency', 'Principal Amount', 'Tenor', 'Interest Rate', 'Interest Amount', 'Maturity Date', 'Maturity Amount']
        const ValueList = [PurchaseAllocationID, ReferenceNo, Instrument, ValueDate, Currency, PrincipalAmount, Tenor, InterestRate, InterestAmount, MaturityDate, MaturityAmount]

        for(let i = 0; i < TitleList.length; i++){
          var data = {
            Title: TitleList[i],
            Value: ValueList[i]
          }
          this.DealNote.push(data);
          if(i == TitleList.length - 1){
            this.generateDealNote(false)
          }
        }
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })
    },

    getCustDealNote(item) {
      this.message = '';
      this.CustDealNote = [];
      this.DealNoteRef = null;

      var data = {
        PurchaseID: item.PurchaseID,
        CustodianID: item.CustodialID
      }

      dealingService.getCustDealNote(data.PurchaseID, data)
      .then(response => {
        this.CustContact = response.data.contacts[0];
        this.DealNoteRef = response.data.data[0].DealNote;
        const { PurchaseId, CustodialId, ReferenceNo, DealNote, Instrument, ValueDate, Currency, PrincipalAmount, Tenor, InterestRate, InterestAmount, MaturityDate, MaturityAmount, TaxRate, TaxAmount, NetMaturityValue } = response.data.data[0]

        const TitleList = ['PurchaseId', 'CustodialId', 'ReferenceNo', 'DealNote', 'Instrument', 'Value Date', 'Currency', 'Principal Amount', 'Tenor', 'Interest Rate', 'Interest Amount', 'Maturity Date', 'Maturity Amount', 'Tax Rate' , 'Tax Amount', 'Net Maturity Value']
        const ValueList = [PurchaseId, CustodialId, ReferenceNo, DealNote, Instrument, ValueDate, Currency, PrincipalAmount, Tenor, InterestRate, InterestAmount, MaturityDate, MaturityAmount, TaxRate, TaxAmount, NetMaturityValue]

        for(let i = 0; i < TitleList.length; i++){
          var data = {
            Title: TitleList[i],
            Value: ValueList[i]
          }
          this.CustDealNote.push(data);
          if(i == TitleList.length - 1){
            this.generateCustDealNote(false)
          }
        }
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })
    },

    getBalances(item) {
      this.message = '';
      var data ={
        CustodialID: item,
        EffectiveDate: this.currentSystemDate.DayDate,
        CurrencyID: this.CurrencyId
      }
      dealingService.getBalances(data.CustodialID, data)
      .then(response => {
        this.balances = response.data[0]
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })
    },

    getCurrentAccountBalance(item) {
      this.message = '';
      var data ={
        AccountID: item.AccountID,
        EffectiveDate: this.currentSystemDate.DayDate
      }
      transactionService.getAccountBalances(data.AccountID, data)
      .then(response => {
        item.OpeningBalance = response.data[0].Available
        return item.OpeningBalance
      })
    },

    getTenorDays(item) {
      var data = {
        PurchaseDate: item,
        MaturityDate: this.MaturityDate,
      };

      if (item != null && this.MaturityDate != null) {
        dealingService.getTenorDays(data)
        .then(response => {
          this.TenorDays = response.data[0].TenorDays
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })
      }
    },

    getMaturityDate(item) {
      var data = {
        PurchaseDate: item,
        TenorDays: this.TenorDays,
      };

      if (item != null && this.TenorDays != null) {
        dealingService.getMaturityDate(data)
        .then(response => {
          this.MaturityDate = response.data[0].MaturityDate
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })
      }
    },

    getNetValueValidation (body, item){
      var data = {
        ClientID: this.allClientAccounts.filter(a => a.AccountID == item.AccountID)[0].ClientID,
        CurrencyID: this.CurrencyId
      }
      administrationService.getNetValue(data.ClientID, data)
      .then(async response => {
        const netValue = await response.data[0].map(r => r.value)[0]

        const accounts = await this.allClientAccounts.filter(a => a.ClientID == data.ClientID).map(a => a.AccountID)

        const sub_total = await body.filter(b => accounts.includes(b.AccountID) == true).map(b => Number(b.AllocationValue)).reduce((a, b) => a + b, 0)

        const total = await sub_total + body.filter(b => accounts.includes(b.AccountID) == true).map(b => Number(b.FldNum03)).reduce((a, b) => a + b, 0)

        if(Number(total) <= Number(netValue)){
          this.BlockingViolation = false
        } else{
          this.BlockingViolation = true
          item.AllocationValue = 0
        }
      })
      return this.BlockingViolation
    },

    generatePDF(IsPrint) {
      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()

        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i)
          // text is placed using x, y coordinates
          doc.setFontSize(10).text("MM Purchases", 0.5, 0.5);
          // create a line under heading 
          doc.setLineWidth(0.01).line(0.5, 0.6, 8.0, 0.6);
          doc.setLineWidth(0.01).line(0.5, 0.8, 8.0, 0.8);
          doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
            align: 'center'
          })
        }
      }

      let doc = new jsPDF({
        orientation: "potrait",
        unit: "in",
        format: "letter"
      });

      doc.setFont('helvetica');
      doc.setFontSize(5);
      doc.autoTable({
        body: this.CurrentDataset,
        margin: { left: 0.5, top: 0.6 },
        styles: {overflow: 'linebreak',
                fontSize: 6},
        showHeader: 'everyPage',
        theme: 'plain'
      });
      addFooters(doc);
      if(IsPrint == true){
        doc.output('dataurlnewwindow');
      } else{
        doc.save('MM Purchases.pdf')
      }
    },

    generateDealNote(IsPrint) {

      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()

        for (var i = 1; i <= pageCount; i++) {
          var imgData = 'data:image/png;base64,'+ this.currentImage[0].data;

          doc.addImage(imgData, 'PNG', 0.5, 0.28, 1.3, 0.7);
          doc.setPage(i)
          // text is placed using x, y coordinates
          doc.setFontSize(10).text(this.identity[0].OrgName, 6.0, 0.4);
          doc.setFontSize(8).text(this.identity[0].Phadd1, 6.0, 0.6);
          doc.setFontSize(8).text(this.allCities.filter(a => a.CityID == this.identity[0].PhCity).map(a => a.City)[0], 6.0, 0.75);
          doc.setFontSize(8).text(this.allCountries.filter(a => a.CountryId == this.identity[0].PhCountry).map(a => a.CountryName)[0], 6.0, 0.9);
          doc.setFontSize(8).text('email: ' + this.identity[0].OrgMail, 6.0, 1.05);
          doc.setFontSize(8).text('cell: ' + this.identity[0].OrgNumber, 6.0, 1.20);
          doc.setFontSize(10).text('Date: ' + this.currentSystemDate.DayDate, 0.5, 1.2);
          doc.setFontSize(10).text(this.Contacts.ClientName == null? '----------' : this.Contacts.ClientName, 0.5, 1.6);
          doc.setFontSize(10).text(this.Contacts.AccNumber == null? '----------' : this.Contacts.AccNumber, 0.5, 1.8);
          doc.setFontSize(10).text(this.Contacts.Postal_Address_1 == null? '----------' : this.Contacts.Postal_Address_1, 0.5, 2.0);
          doc.setFontSize(10).text(this.Contacts.Postal_Address_2 == null? '----------' : this.Contacts.Postal_Address_2, 0.5, 2.2);
          doc.setFontSize(10).text(this.Contacts.Postal_Address_3 == null? '----------' : this.Contacts.Postal_Address_3, 0.5, 2.4);
          doc.setFontSize(10).text(this.Contacts.Postal_City == null? '----------' : this.Contacts.Postal_City, 0.5, 2.6);
          doc.setFontSize(10).text(this.Contacts.NametoContact == null? '----------' : this.Contacts.NametoContact, 0.5, 2.8);
          doc.setFontSize(10).text(this.Contacts.Currency == null? '----------' : this.Contacts.Currency, 0.5, 3.0);
          doc.setFontSize(13).text('Deal Confirmation Reference No: ' + this.DealNoteAllocationNo, 0.5, 3.4);
          doc.setFontSize(10).text('We confirm having accepted from yourself a contribution and details are shown below:-', 0.5, 3.8);
          doc.setFontSize(10).text('We acknowledge receipt of the principal amount.', 0.5, 7.3);
          doc.setFontSize(10).text('For our mutual convenience, we suggest that you contact us on the day of maturity of this contract to advise your intentions', 0.5, 7.5);
          doc.setFontSize(10).text('regarding the proceeds.', 0.5, 7.7);
          doc.setFontSize(10).text('Yours Faithfully', 0.5, 8.3);
          doc.setFontSize(10).text('for ' + this.identity[0].OrgName, 0.5, 8.5);
          // create a line under heading 
          doc.setLineWidth(0.01).line(0.5, 4.0, 8.0, 4.0);
          doc.setLineWidth(0.01).line(0.5, 7, 8.0, 7);
          doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
            align: 'center'
          })
        }
      }

      let doc = new jsPDF({
        orientation: "potrait",
        unit: "in",
        format: "letter"
      });

      var newDealNote = this.DealNote;
      newDealNote.splice(0, 2);

      doc.setFont('helvetica');
      doc.setFontSize(5);
      doc.autoTable({
        body: newDealNote,
        margin: { left: 0.5, top: 4.2, right: 3.0 },
        styles: {overflow: 'linebreak',
                fontSize: 10},
        columnStyles: {
          1: {
              halign: 'right'
          },
        },
        showHeader: 'everyPage',
        theme: 'plain'
      });
      addFooters(doc);
      if(IsPrint == true){
        doc.output('dataurlnewwindow');
      } else{
        this.DealNoteUri = doc.output('datauristring');
      }
    },

    generateCustDealNote(IsPrint) {

      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()

        for (var i = 1; i <= pageCount; i++) {
          var imgData = 'data:image/png;base64,'+ this.currentImage[0].data;

          doc.addImage(imgData, 'PNG', 0.5, 0.28, 1.3, 0.7);
          doc.setPage(i)
          // text is placed using x, y coordinates
          doc.setFontSize(10).text(this.identity[0].OrgName, 6.0, 0.4);
          doc.setFontSize(8).text(this.identity[0].Phadd1, 6.0, 0.6);
          doc.setFontSize(8).text(this.allCities.filter(a => a.CityID == this.identity[0].PhCity).map(a => a.City)[0], 6.0, 0.75);
          doc.setFontSize(8).text(this.allCountries.filter(a => a.CountryId == this.identity[0].PhCountry).map(a => a.CountryName)[0], 6.0, 0.9);
          doc.setFontSize(8).text('email: ' + this.identity[0].OrgMail, 6.0, 1.05);
          doc.setFontSize(8).text('cell: ' + this.identity[0].OrgNumber, 6.0, 1.20);
          doc.setFontSize(10).text('Date: ' + this.currentSystemDate.DayDate, 0.5, 1.2);
          doc.setFontSize(10).text(this.DealCustodians.filter(a => a.CustodianID == this.currentPurchase.CustodialID).map(a => a.CustodianName).toLocaleString(), 0.5, 1.6);
          doc.setFontSize(10).text(this.CustContact.Phone == null? '----------' : this.CustContact.Phone, 0.5, 1.8);
          doc.setFontSize(10).text(this.CustContact.Email == null? '----------' : this.CustContact.Email, 0.5, 2.0);
          doc.setFontSize(10).text(this.CustContact.Postal_Address_1 == null? '----------' : this.CustContact.Postal_Address_1, 0.5, 2.2);
          doc.setFontSize(10).text(this.CustContact.Postal_Address_2 == null? '----------' : this.CustContact.Postal_Address_2, 0.5, 2.4);
          doc.setFontSize(10).text(this.CustContact.Postal_Address_3 == null? '----------' : this.CustContact.Postal_Address_3, 0.5, 2.6);
          doc.setFontSize(10).text(this.CustContact.Postal_City == null? '----------' : this.CustContact.Postal_City, 0.5, 2.8);
          doc.setFontSize(10).text(this.CustContact.Postal_Country == null? '----------' : this.CustContact.Postal_Country, 0.5, 3.0);
          doc.setFontSize(13).text('Deal Confirmation Reference No: ' + this.DealNoteRef, 0.5, 3.4);
          doc.setFontSize(10).text('We confirm having purchased the following asset from you:-', 0.5, 3.8);
          doc.setFontSize(10).text('Kindly acknowledge receipt of funds by signing and returning a copy of the confirmation.', 0.5, 8.2);
          doc.setFontSize(10).text('Yours Faithfully', 0.5, 8.7);
          doc.setFontSize(10).text('for ' + this.identity[0].OrgName, 0.5, 8.9);
          doc.setFontSize(10).text('Acknowledgement:    ...............................................', 0.5, 9.9);
          doc.setFontSize(10).text('Company Stamp:    ...............................................', 5.0, 9.9);
          // create a line under heading 
          doc.setLineWidth(0.01).line(0.5, 4.0, 8.0, 4.0);
          doc.setLineWidth(0.01).line(0.5, 7.9, 8.0, 7.9);
          doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
            align: 'center'
          })
        }
      }

      let doc = new jsPDF({
        orientation: "potrait",
        unit: "in",
        format: "letter"
      });

      var newDealNote = this.CustDealNote;
      newDealNote.splice(0, 4);

      doc.setFont('helvetica');
      doc.setFontSize(5);
      doc.autoTable({
        body: newDealNote,
        margin: { left: 0.5, top: 4.2, right: 3.0 },
        styles: {overflow: 'linebreak',
                fontSize: 10},
        columnStyles: {
          1: {
              halign: 'right'
          },
        },
        showHeader: 'everyPage',
        theme: 'plain'
      });
      addFooters(doc);
      if(IsPrint == true){
        doc.output('dataurlnewwindow');
      } else{
        this.CustDealNoteUri = doc.output('datauristring');
      }
    },

    getWith_holdingTax(item){
      if(this.GrossInterest != null && item.TaxRate != null){
        this.WithHoldingTax = Number(this.GrossInterest) * (Number(item.TaxRate) / 100)
      }
    },

    CheckDiscountStatus(){
      if(this.create == true){
        return this.allInstrumentTypes.filter(a => a.InstrumentTypeID == this.MMPurchase.purchase.InstrumentID).map(a => a.IsDiscount)[0]
      } else if(this.edit == true){
        return this.allInstrumentTypes.filter(a => a.InstrumentTypeID == this.currentPurchase.InstrumentID).map(a => a.IsDiscount)[0]
      }
    },

    getInterest(item, parent){
      item.FldNum02 = (item.AllocationValue/parent.InstrumentValue) * this.GrossInterest
      return item.FldNum02
    },

    getMaturityValue(item){
      // item.FldNum01 = Number(item.AllocationValue) + Number(item.FldNum02) - Number(item.FldNum03)
      item.FldNum01 = Number(item.AllocationValue * (1 + ((item.AllocationRate/100) * (this.TenorDays/this.InterestDenominator)))) - Number(item.FldNum03)
      return item.FldNum01
    },

    getCharges(item, parent){
      item.FldNum03 = (item.AllocationValue/parent.InstrumentValue) * (Number(this.GrossInterest) * (Number(parent.TaxRate) / 100))
      return item.FldNum03
    },

    getAllocationRate(item, parent){
      item.AllocationRate = parent.Rate;
      return item.AllocationRate
    },

    getClosingBalance(item) {
      item.ClosingBalance = Number(item.OpeningBalance) - item.AllocationValue;
      return item.ClosingBalance
    },

    GetGrossInterest(item, date) {
      var data = {
        PurchaseDate: date,
        MaturityDate: this.MaturityDate,
        DealRate: item.Rate,
        InstrumentValue: item.InstrumentValue,
        InterestDenominator: this.InterestDenominator
      }
      if (date != null && this.MaturityDate != null && item.Rate != null && item.InstrumentValue != null && this.InterestDenominator > 0) {
        this.loading = true,
        dealingService.getGrossInterest(data)
        .then(response => {
          this.GrossInterest = response.data[0].MMGrossInterest
          this.loading = false;
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false;
        })
      }
    },

    __getInterestDenominator(){
      if(this.MMPurchase.purchase.FldVar01 != null && this.MMPurchase.purchase.FldVar01 != ''){
        this.InterestDenominator = Number(this.Basis.filter(b => b.BasisIdAlpha == this.MMPurchase.purchase.FldVar01).map(b => b.Basis)[0])
      } else if(this.currentPurchase && this.currentPurchase.FldVar01 != null && this.currentPurchase.FldVar01 != '' ){
        this.InterestDenominator = Number(this.Basis.filter(b => b.BasisIdAlpha == this.currentPurchase.FldVar01).map(b => b.Basis)[0])
      } else {
        this.InterestDenominator = 0
      }
    },

    getInterestDenominator() {
      var data = {
        CurrencyID: this.CurrencyId,
      };

      if (this.CurrencyId != null) {
        dealingService.getInstrumentDenominator(data)
        .then(response => {
          this.InterestDenominator = response.data[0].InterestDenominator
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })
      }
    },

    mapCurrency(currency) {
      return this.CurrencyId = currency.CurrencyID
    },

    allowedDates: val => val <= new Date().toISOString().split('T')[0],

    getCustodianName(id) {
      return this.DealCustodians.filter(a => a.CustodianID === id).map(a => a.CustodianName).toLocaleString()
    },

    getAllocatedValue(item) {
      return item.map(i => Number(i.AllocationValue)).reduce((a, b) => a + b, 0);
    },

    getAllocatedUnits(item) {
      return item.map(i => Number(i.FldNum01)).reduce((a, b) => a + b, 0);
    },

    getAccounts(item) {
      var data = {
        CustodialID: item,
        CurrencyID: this.CurrencyId,
        Taxable: this.Taxable,
        Counter: 0
      }
      if(item != null){
        dealingService.getCustodianAccounts(data.CustodialID, data)
        .then(response => {
          this.Accounts = response.data
        })
      }
    },

    NewAllocation(item) {
      item.push(
        {
          AccountID: null,
          FldNum01: '',
          FldNum02: '',
          FldNum03: '',
          FldBit02: 0,
          OpeningBalance: '',
          AllocationValue: '',
          AllocationRate: ''
        }
      )
    },

    removeAllocation(item, parent) {
      const index = parent.findIndex(p => p.AccountID === item.AccountID);
      parent.splice(index, 1)
    },

    getFiltered(current){
      this.CurrentDataset = current;
    },

    unconfirmed() {
      this.confirmedPurchases = false
    },

    showEdit () {
      this.edit = true;
    },

    closeEdit() {
      this.currentPurchase = null,
      this.balances = {},
      this.MaturityDate = '',
      this.TenorDays = 0,
      this.Taxable = false,
      this.GrossInterest = 0,
      this.WithHoldingTax = 0,
      this.edit = false
    },

    showCreate () {
      this.create = true;
      this.getMaturityDate(this.currentSystemDate.DayDate);
      this.MMPurchase.purchase.TaxRate = 0;
    },

    closeCreate() {
      this.balances = {},
      this.MaturityDate = '',
      this.TenorDays = 0,
      this.Taxable = false,
      this.MMPurchase.allocation = [],
      this.MMPurchase.purchase = {},
      this.GrossInterest = 0,
      this.WithHoldingTax = 0,
      this.create = false
    },

    reject () {
      this.dialog = true
    },

    close () {
      this.dialog = false
      this.RejectionStatus = 0
    },

    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },

    validate () {
      this.$refs.form.validate()
      return this.valid
    },

    reset () {
      this.$refs.form.reset()
    },

    async EditAllocation (item) {
      if(this.view != true){
        for (let i = 0; i < item.allocations.length; i++) {
          await this.getCurrentAccountBalance(item.allocations[i])
        }
        return item
      } else {
        return item
      }
    },

    async setActivePurchase (item, index) {
      const purchase = await this.EditAllocation(item)

      this.currentPurchase = purchase;
      this.currentIndex = index;
      this.MaturityDate = purchase.MaturityDate

      this.__getInterestDenominator()
      this.getBalances(purchase.CustodialID)
      this.getAccounts(purchase.CustodialID)
    },

    setActiveAllocation (item, index) {
      this.currentAllocation = item
      this.allocationIndex = index
    },
  },

  mounted () {
    UserService.isPurchaseMoneyMarket().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
    this.$root.$on("unconfirmedMMPurchases", () => {
      this.unconfirmed();
    });
  }
}
</script>

<style scoped>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.edit {
  background-color: #DBEFFA;
}

.v-btn {
  outline: none
}

/* .v-select__selections input {
  display: none;
} */

.Account {
  width: 300px;
}

.my-allocations-table{
  table-layout : fixed;
}

.table-text-field{
  width: 170px;
}

.headline {
  color:white
}
</style>
